// extracted by mini-css-extract-plugin
export default {"tabBody":"tabBody_O8hWg","left":"left_dUCvd","right":"right_pVVE_"};